module.exports = __webpack_public_path__ + "static/media/chalkys-logo.3c1bd07c.png";